import { Link } from 'react-router';
import { Button } from '~/components/ui/button';

export default function NotFoundPage() {
  return (
    <div className='flex min-h-screen items-center justify-center bg-background p-4'>
      <div className='text-center space-y-4'>
        <h1 className='text-6xl font-bold text-primary'>404</h1>
        <h2 className='text-2xl font-semibold'>Page Not Found</h2>
        <p className='text-muted-foreground max-w-md'>
          The page you're looking for doesn't exist or you don't have permission to access it.
        </p>
        <Button asChild>
          <Link to='/'>Go to Dashboard</Link>
        </Button>
      </div>
    </div>
  );
}
